import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';

interface IGoatCleanCard {
  title: string;
  description: string | string[];
  image: string;
  stepNumber: number;
}

export const GoatCleanCard = ({ title, description, image, stepNumber }: IGoatCleanCard) => {
  return (
    <GoatCleanCard.Container>
      <GoatCleanCard.Image alt={title} data-qa="goat_clean_image" src={image} />
      <GoatCleanCard.Number>{`0${stepNumber}/06`}</GoatCleanCard.Number>
      <GoatCleanCard.StepTitle>{title}</GoatCleanCard.StepTitle>
      {Array.isArray(description) ? (
        <GoatCleanCard.Description>
          {description.map((line) => (
            <GoatCleanCard.GradeSection key={line}>{line}</GoatCleanCard.GradeSection>
          ))}
        </GoatCleanCard.Description>
      ) : (
        <GoatCleanCard.Description>{description}</GoatCleanCard.Description>
      )}
    </GoatCleanCard.Container>
  );
};

GoatCleanCard.Container = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1 0 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    flex: 1 0 30%;
    margin-bottom: 84px;
    margin-right: 24px;
  }
`;

GoatCleanCard.Image = styled.img`
  width: 100%;
  margin-bottom: 16px;
`;

GoatCleanCard.Number = styled.span`
  font-weight: 400;
  margin-bottom: 16px;
  text-transform: uppercase;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};
`;

GoatCleanCard.StepTitle = styled.h2`
  font-weight: 500;
  margin-bottom: 16px;
  text-transform: capitalize;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};
`;

GoatCleanCard.Description = styled.div`
  font-weight: 400;
  ${variableFontRegular({ size: '11.5px', height: '13.2px' })};
  margin-bottom: 16px;
`;

GoatCleanCard.GradeSection = styled.div`
  font-weight: 400;
  margin-bottom: 16px;

  ${variableFontRegular({ size: '11.5px', height: '14px' })};
`;
